import { HistoryIcon, SparklesIcon } from "lucide-react"
import React from "react"
import { DialogTitle } from "../common/dialog"
import { Badge } from "../common/badge"
import useTranslator from "@hooks/use-translator"
const TopBar = () => {
  const { translate } = useTranslator()
  return (
    <div className='flex items-center'>
      <div className='flex items-center gap-2'>
        <SparklesIcon color='blue' />
        <DialogTitle>{translate("Ask ai")}</DialogTitle>
        <Badge variant='outline' className='text-gray-400'>
          {"Beta"}
        </Badge>
      </div>
    </div>
  )
}

export default TopBar
